export const TEST_QUESTION_SOURCE = {
  ALL: 'all',
  COMPLETED_LEVELS: 'completed_levels',
} as const;

export type TestQuestionSource =
  (typeof TEST_QUESTION_SOURCE)[keyof typeof TEST_QUESTION_SOURCE];

export const TEST_QUESTION_SOURCE_OPTIONS: {
  value: TestQuestionSource;
  label: string;
}[] = [
  { value: TEST_QUESTION_SOURCE.ALL, label: 'All' },
  { value: TEST_QUESTION_SOURCE.COMPLETED_LEVELS, label: 'Completed Levels' },
];
